import React, { useState } from "react";
import { motion } from "framer-motion";
import { Form } from "react-bootstrap";

export default function SystemMaintenanceMode() {
  const [preview, setPreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Maintenance Mode
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
      >
        <div className="card-body">

          <Form>

            {/* IMAGE */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>Image</Form.Label>
              </div>

              <div className="col-md-6 d-flex align-items-center gap-3">

                {/* Preview box (Bootstrap only) */}
                <div
                  className="bg-light rounded d-flex align-items-center justify-content-center overflow-hidden"
                  style={{ width: "80px", height: "80px" }}
                >
                  {preview ? (
                    <motion.img
                      src={preview}
                      alt="preview"
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                    />
                  ) : (
                    <i className="bi bi-image text-muted fs-4"></i>
                  )}
                </div>

                <div>
                  <Form.Control type="file" onChange={handleImageChange} />
                  <small className="text-muted">
                    Recommended size: 500px × 400px
                  </small>
                </div>

              </div>
            </div>

            {/* DESCRIPTION */}
            <div className="row mb-3">
              <div className="col-md-3">
                <Form.Label>Description</Form.Label>
              </div>
              <div className="col-md-6">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter maintenance message..."
                />
              </div>
            </div>

            {/* STATUS */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>Status</Form.Label>
              </div>
              <div className="col-md-6">
                <Form.Check type="switch" />
              </div>
            </div>

          </Form>
        </div>
      </motion.div>

      {/* FOOTER */}
      <motion.div
        className="d-flex justify-content-end gap-2 mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-secondary"
        >
          Cancel
        </motion.button>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-success"
        >
          Save Changes
        </motion.button>
      </motion.div>
    </motion.div>
  );
}